import React from "react";
import { CAlert, } from "@coreui/react";

const AppMessage = ({
  type = "info", // info, success, warning, danger
  title,
  message,
  style = {},
  children,
  showHomeButton = false,
}) => {
  // const navigate = useNavigate();

  const colorMap = {
    error: "danger",
    success: "success",
    warning: "warning",
    info: "info",
  };

  const color = colorMap[type] || "info";

  return (
    // <div className="w-100 px-3 px-md-1 my-4">
      <CAlert
        color={color}
        className="w-100 text-center rounded-3 "
        style={{
          width: "100%",
          backgroundColor: "var(--cui-alert-bg)", // fallback or use theme background
          ...style,
        }}
      >
        {title && <h5 className="fw-bold mb-2">{title}</h5>}
        {message && <p className="mb-2 mb-md-1">{message}</p>}
        {children}
      </CAlert>
    // </div>
  );
};

export default AppMessage;
